import { Injectable } from "@angular/core";

@Injectable()
export class SessionService {

    getItem(input) {
        return sessionStorage.getItem(input);
    }
    setItem(input, value) {
        sessionStorage.setItem(input, value);
    }

    clearAll() {
        sessionStorage.clear();
    }
    removeItem(input) {
        sessionStorage.removeItem(input);
    }
}